<template>
  <span class="attachment-name">
    <span v-if="attachment.name">
      {{attachment.name}}
    </span>
    <span v-else>
      <span v-if="fallbackName">{{fallbackName}}</span>
      <text-placeholder v-else />
    </span>
  </span>
</template>

<script>
import last from 'lodash/last';

export default {
  name: 'attachment-name',
  props: {
    attachment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fallbackName() {
      return this.attachment.fileName || this.filenameFromUrl;
    },
    filenameFromUrl() {
      const url = this.attachment.url;
      if (this.attachment.remote) return url;
      return last(url.split('/'));
    },
  },
};
</script>



// WEBPACK FOOTER //
// AttachmentName.vue?df94fbac